import { useEffect, type ReactNode } from 'react';
import { supabase } from '@/lib/supabase';
import { useAuthStore } from '@/stores/auth-store';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { setSession, setProfile, setLoading, clear } = useAuthStore();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session?.user) {
        loadProfile(session.user.id);
      } else {
        setLoading(false);
      }
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (session?.user) {
        loadProfile(session.user.id);
      } else {
        clear();
      }
    });

    return () => subscription.unsubscribe();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function loadProfile(userId: string) {
    const { data, error } = await supabase
      .from('profile')
      .select('id, tenant_id, email, full_name, avatar_url, role')
      .eq('id', userId)
      .single();

    if (error || !data) {
      clear();
      return;
    }

    setProfile({
      id: data.id,
      tenant_id: data.tenant_id,
      email: data.email,
      full_name: data.full_name,
      avatar_url: data.avatar_url,
      role: data.role,
    });
    setLoading(false);
  }

  return <>{children}</>;
}
